<template>
    <div class="enterprise-category-wrapper">
        <div class="container margin-b20 flex-sb">
            <div class="title flex-all-center">企业类目映射
                <el-tooltip class="item" effect="dark" placement="top">
                    <template v-slot:content>
                    1. 企业末级类目与平台类目以最末级建立映射关系；<br>
                    2. 企业类目需列到三级，若小于3个层级，填写上级类目补齐；<br>
                    3. 企业类目名称为必填项，类目编码可选填。
                </template>
                    <div class="empty-mark"></div>
                </el-tooltip>
            </div>
<!--            v-permission="['/product/purchaseCategory/changeSwitch']"-->
            <div class="title"  >使用企业类目模式
                <el-switch v-model="mdgSwitch" style="margin-left: 20px" @change="purchaseCategoryChangeSwitch"></el-switch>
            </div>
        </div>
        <div class="tab-choose-wrapper flex-sb">
            <div class="step-box flex">
                <div v-for="(item,index) in stepData" :key="index">
                    <div class="step-content" :class="{
                  'border-right': index === 3,
                   'active-item':activeIndex === index,
                    'border-bottom':activeIndex === 0}"
                         @click="handleActive(index)">{{item}}
                    </div>
                </div>
            </div>
<!--            v-permission="['/product/purchaseCategory/removeAll']"-->
            <div class="del-box" v-if="activeIndex === 0 " @click="handleDelAll">全部删除</div>
            <div class="del-box export-box" v-if="activeIndex === 3" @click="mdgCategoryExport">导出</div>
        </div>
        <!--单条新增-->
        <single-addition v-if="activeIndex === 0" ref="singleAddition"/>
        <!--批量导入-->
        <batch-import v-if="activeIndex === 1"/>
        <!-- 历史导入详情-->
        <historical-import-details v-if="activeIndex === 2"/>
        <!--查看映射列表-->
        <view-mapping-list v-if="activeIndex === 3" />
    </div>
</template>

<script>
    import singleAddition from './common/singleAddition';
    import batchImport from './common/batchImport';
    import historicalImportDetails from './common/historicalImportDetails';
    import viewMappingList from './common/viewMappingList';
    import api from '@/modules/projectA/api/purchase';
    import utils from "@/modules/projectA/utils/utils";
    import authorityApi from '../../api/authority';
    export default {
        name: "index",
        components: {
            singleAddition,
            batchImport,
            historicalImportDetails,
            viewMappingList
        },
        data() {
            return {
                userInfo:{},
                mdgSwitch:false,
                activeIndex: 0,
                stepData: ['单条新增', '批量导入', '历史导入详情', '查看映射列表'],
            }
        },
        methods: {
            //导出
            mdgCategoryExport(){
                api.mdgCategoryExport().then(res => {
                    if (res.type == "application/json") {
                        utils.fileExportResponseError(res);
                    } else {
                        utils.downFile(res);
                    }
                });
            },
            //全部删除
            handleDelAll(){
                this.$confirm('将删除全部导购分类及其与平台分类映射关系，并清空映射列表。', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    api.purchaseRemoveAll().then(res => {
                        if (res.success) {
                            this.$refs.singleAddition.queryPurchaseCategoryTree();
                            this.mdgSwitch = false;
                            this.purchaseCategoryChangeSwitch();
                        }
                    });
                })

            },
            handleActive(index) {
                this.activeIndex = index;
            },
            //查看企业类目开关状态：0-关闭，1-开启
            purchaseCategorySwitch(){
                api.purchaseCategorySwitch().then(res => {
                    if (res.success) {
                        this.mdgSwitch = res.data ? true : false;
                    }
                });
            },
            // 改变企业类目开关状态：0-关闭，1-开启
            purchaseCategoryChangeSwitch(){
                api.purchaseCategoryChangeSwitch({mdgSwitch: this.mdgSwitch ? 1 : 0}).then(res => {
                    if (res.success) {
                        if(this.mdgSwitch){
                            this.mdgSwitch = true;
                        }else{
                            this.mdgSwitch = false;
                        }
                    }else{
                        this.mdgSwitch = false;
                    }
                });
            },
        },
        mounted() {
            this.userInfo = JSON.parse(localStorage.getItem('USERINFO'));
            this.purchaseCategorySwitch();
        }
    }
</script>

<style scoped lang="scss">
    .enterprise-category-wrapper {
        .title {
            font-size: 16px;
            color: #333;
            font-weight: 500;
        }
        .empty-mark {
            margin-left: 6px;
            background: url("../../../../assets/img/common/query-empty-mark.png") no-repeat;
            background-size: 18px 18px;
            width: 18px;
            height: 18px;
            cursor: pointer;

            &:hover {
                background-image: url("../../../../assets/img/common/real-mark.png");
            }
        }

        .tab-choose-wrapper {
            .step-box {
                .step-content {
                    width: 148px;
                    height: 40px;
                    line-height: 40px;
                    background-color: #FFF;
                    text-align: center;
                    border: 1px solid #D9D9D9;
                    border-right: none;
                    cursor: pointer;
                }

                .border-right {
                    border-right: 1px solid #D9D9D9;
                }

                .border-bottom {
                    border-bottom: none;
                }

                .active-item {
                    border-top: 2px solid #2587FF;
                    background: #F4F7FF;
                    color: #2587FF;
                    height: 40px;
                    border-bottom: none;
                }
            }

            .del-box {
                width: 88px;
                height: 30px;
                text-align: center;
                line-height: 30px;
                color: #E50113;
                border: 1px solid #E50113;
                background: #FFF;
                cursor: pointer;
                font-weight: 350;

                &:hover {
                    color: #FFF;
                    background: #E50113;
                }
            }
            .export-box{
                color: #2587FF;
                border: 1px solid #2587FF;
                background: #FFF;
                &:hover {
                    color: #FFF;
                    background: #2587FF;
                }
            }
        }
    }

</style>